
import { LanguageContextApi } from './language.types';
import { contextFactory } from '../../helpers';

const [LanguageContext, useLanguage] = contextFactory<LanguageContextApi>({
  hook: 'useLanguageContext',
  provider: 'LanguageProvider',
});

export { useLanguage, LanguageContext };
